import type { AdminViewDefinition } from "../../../components/admin-components.js";

export const installationDirectoryAdminViews: AdminViewDefinition[] = [
  installationsListView(),
  uninstalledStoresView(),
];

export function installationsListView(): AdminViewDefinition {
  return {
    id: "installations-list",
    navId: "installations",
    title: "Installed  Stores",
    description:
      "Search and monitor installation state, token health, sync status, plan, and usage.",
    actions: [
      { label: "Uninstalled stores", routeId: "uninstalled-stores", routePresentation: "page" },
    ],
  };
}

function uninstalledStoresView(): AdminViewDefinition {
  return {
    id: "uninstalled-stores",
    navId: "installations",
    title: "Uninstalled Stores",
    description:
      "Review uninstall history, data-retention state, privacy work, and retained operational summaries.",
    actions: [
      { label: "Back to installations", routeId: "installations-list", routePresentation: "page" },
    ],
    filters: ["Uninstalled date", "Retention state", "Compliance job", "Legal hold"],
  };
}
